// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonWithIcon_button__2iEFt","icon":"ButtonWithIcon_icon__QP01s"};